export default __webpack_public_path__ + "0bc46080d9fbc348257c28961c5e458f.png";